'use client';

import Link from 'next/link';
import copy from 'copy-to-clipboard';
import type { FC, PropsWithChildren } from 'react';

interface CopyLinkProps extends PropsWithChildren {
	className?: string;
	href: string;
	onClick?: () => void;
}

export const CopyLink: FC<CopyLinkProps> = ({
	children,
	className,
	href,
	onClick,
}) => {
	const handleClick = () => {
		const fullUrl = window.location.href.split('#')[0] + href;
		copy(fullUrl);

		// Call the passed onClick handler if it exists
		if (onClick) {
			onClick();
		}
	};

	return (
		<Link className={className} href={href} onClick={handleClick}>
			{children}
		</Link>
	);
};
